let _this = null

const setThis = function(__this) {
  _this = __this
}

export default {
  setThis,
  //采购审核 绑定同意操作
  agreeClick() {
    _this.isAgree = 1
    this.confirmAudit('审核意见 ')
  },
  //绑定拒绝操作
  refuseClick() {
    _this.isAgree = 2
    this.confirmAudit('请输入不同意审核意见 ')
  },
  confirmAudit(val) {
    const h = _this.$createElement
    _this.$prompt(
      h('p', null, [
        h('span', null, '审批金额：' + _this.je),
        h('br'),
        h('span', { style: 'font-size: 15px;margin-top: 10px' }, val)
      ]), '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(({ value }) => {
      const loading = _this.$loading({
        lock: true,
        text: '审核中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      _this.shyj = value
      const data = {
        userNo: localStorage.getItem('userNo'),
        flowId: _this.flowId,
        maindjh: _this.djh,
        lb: 'fksqd',
        shr: localStorage.getItem('userName'),
        shrNo: localStorage.getItem('userNo'),
        shje: _this.je,
        shyj: _this.shyj === '' ? '  ' : _this.shyj,
        isAgree: _this.isAgree,
        documentType: _this.documentType,
        extendJSON: _this.property
      }
      _this.$post('/fesback/purchase/workflowAudit.z', data).then(response => {
        if (response.success) {
          _this.$message(response.message)
          _this.findPage()
          _this.fksqdClose()
        } else {
          _this.$message(response.message)
        }
        loading.close()
      })
    })
  },
  convertCurrency(money) {
    //汉字的数字
    var cnNums = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖']
    //基本单位
    var cnIntRadice = ['', '拾', '佰', '仟']
    //对应整数部分扩展单位
    var cnIntUnits = ['', '万', '亿', '兆']
    //对应小数部分单位
    var cnDecUnits = ['角', '分', '毫', '厘']
    //整数金额时后面跟的字符
    var cnInteger = '整'
    //整型完以后的单位
    var cnIntLast = '元'
    //最大处理的数字
    var maxNum = 999999999999999.9999
    //金额整数部分
    var integerNum
    //金额小数部分
    var decimalNum
    //输出的中文金额字符串
    var chineseStr = ''
    //分离金额后用的数组，预定义
    var parts
    if (money === '') { return '' }
    money = parseFloat(money)
    if (money >= maxNum) {
      //超出最大处理数字
      return ''
    }
    if (money === 0) {
      chineseStr = cnNums[0] + cnIntLast + cnInteger
      return chineseStr
    }
    //转换为字符串
    money = money.toString()
    if (money.indexOf('.') === -1) {
      integerNum = money
      decimalNum = ''
    } else {
      parts = money.split('.')
      integerNum = parts[0]
      decimalNum = parts[1].substr(0, 4)
    }
    //获取整型部分转换
    if (parseInt(integerNum, 10) > 0) {
      var zeroCount = 0
      var IntLen = integerNum.length
      for (var i = 0; i < IntLen; i++) {
        var n = integerNum.substr(i, 1)
        var p = IntLen - i - 1
        var q = p / 4
        var m = p % 4
        if (n === '0') {
          zeroCount++
        } else {
          if (zeroCount > 0) {
            chineseStr += cnNums[0]
          }
          //归零
          zeroCount = 0
          chineseStr += cnNums[parseInt(n)] + cnIntRadice[m]
        }
        if (m === 0 && zeroCount < 4) {
          chineseStr += cnIntUnits[q]
        }
      }
      chineseStr += cnIntLast
    }
    //小数部分
    if (decimalNum !== '') {
      const decLen = decimalNum.length
      for (let i = 0; i < decLen; i++) {
        const n = decimalNum.substr(i, 1)
        if (n !== '0') {
          chineseStr += cnNums[Number(n)] + cnDecUnits[i]
        }
      }
    }
    if (chineseStr === '') {
      chineseStr += cnNums[0] + cnIntLast + cnInteger
    } else if (decimalNum === '') {
      chineseStr += cnInteger
    }
    return chineseStr
  },
  formatAmount(value) {
    //传入值不是数字直接返回0
    if (!value) return '0.00'
    const values = value.toString().split('.')
    // 整数部分
    let integerNum = values[0]
    // 小数部分
    let decimalNum = values[1] ? values[1] : '00'
    decimalNum = decimalNum.length === 1 ? decimalNum + 0 : decimalNum
    //传入值小于1000不切割
    if (integerNum < 1000) {
      return `${integerNum}.${decimalNum}`
    }
    const list = []
    while (integerNum.length > 3) {
      // 倒序切割
      list.unshift(integerNum.slice(-3))
      integerNum = integerNum.slice(0, -3)
    }
    // 处理剩余长度
    list.unshift(integerNum)
    return `${list.join(',')}.${decimalNum}`
  },
  getPurchaseCgNameByCode(row) {
    if (row.ywbm === '菲麦森业务' || row.documentType === 'fms') return '宁夏菲麦森工业软件技术有限公司'
    return row.documentType === 'wzyb' ? '吴忠仪表有限责任公司' : (row.documentType === 'ic' ? '吴忠仪表智能控制装备技术有限公司' : '吴忠仪表执行器技术有限公司')
  }
}
